import {
  Card,
  Grid,
  TextField,
  Button
} from "@mui/material";
import { Link } from "react-router-dom";
import './ServiceCard.css'
import { logEvent } from "../../../utils/analytics";

function DonationCard(props) {
  const {
    i,
    handleDonationAmount,
    donationAmount,
    handleOrderPuja,
    errorMessage
  } = props;

  const handleImageClick = (donation) => {
    logEvent("Donation Interaction", "Image Clicked", donation.title);
  };

  return (
    <Card>
      <Grid container padding={2} spacing={1}>
        <Grid item xs={12} sx={{ borderRadius: 5,height:'280px' }}>
            <Link
              to={`/donation/${i.slug}`}
              onClick={() => {handleImageClick(i)}}
            >
              <img
                style={{
                  width: "100%",
                  height: "280px",
                  borderRadius: 20,
                  padding: 10,
                }}
                src={i.image}
                alt={i.title}
              />
            </Link>
          
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center", height: 50, mb: 1 }}>
          <h5 className="mb-0 religious-services-title">{i.title} ${i.amount}</h5>
        </Grid>
        <Grid item xs={12}>
          <Grid container >
            <Grid item xs={12} padding={1} spacing={1}>
              <TextField
                value={donationAmount[i?._id] || ""}
                onChange={(e) => handleDonationAmount(i, e)}
                label="Donations in $"
                id="outlined-size-normal"
                error={!!errorMessage[i._id]} // Show error if it exists
                helperText={errorMessage[i._id]} // Show error message
              />
            </Grid>
            <Grid item xs={12} padding={1} spacing={1}>
               <Button
                    variant="contained"
                    color="primary"
                    className="request_puja_btn"
                    onClick={() => {
                    handleOrderPuja(i);
                    logEvent(
                        "Donation",
                        "Request for Donation",
                        i.title
                    );
                    }}
                    disabled={!!errorMessage[i._id]}
                >
                    Add to Basket
                </Button>
            </Grid>
            <Grid item xs={12} padding={1} spacing={1}>
              <div
                className="service-content-bdr truncate"
                dangerouslySetInnerHTML={{
                 __html: i?.description,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default DonationCard;
